module.exports = __webpack_public_path__ + "img/smooth.f21a7ffe.jpg";